import { Theme, css } from '@emotion/react';

import { useEffect } from 'react';

import useToastStore from '@stores/useToastStore';
import { Radius, Spacing, Typography } from 'chatie-design-system';

export const TOAST_ANIMATION_TIME = {
  TIME_OUT: 2,
  FADE_IN_DELAY: 0.1,
  FADE_IN_DURATION: 0.2,
  FADE_OUT_DELAY: 2,
  FADE_OUT_DURATION: 0.3,
};

const TOAST_COLOR = '#000a2ed9';

const toastContainerCSS = () => css`
  width: 100%;
  max-width: 500px;

  .toastWrapper {
    display: flex;
    flex: 1;
    position: fixed;
    width: 100%;
    z-index: 100;
    bottom: 0;
    z-index: 101;
    flex-direction: column;
    align-items: center;
  }
`;

const contentContainerCSS = (height?: number) => (theme: Theme) =>
  css`
    display: flex;
    flex: 1;
    justify-content: center;
    opacity: 0;
    padding: ${Spacing.small}px ${Spacing.medium}px;
    max-width: 468px;
    width: calc(100% - ${Spacing.medium * 2}px);
    border-radius: ${Radius.medium}px;
    background-color: ${TOAST_COLOR};
    color: ${theme.var.white};
    margin-top: ${Spacing.xsmall}px;
    position: absolute;

    ${height &&
    css`
      bottom: calc(env(safe-area-inset-bottom) + ${height}px);
    `}

    ${Typography.body14}
    line-height: 19px;
    white-space: pre-wrap;
    word-break: break-all;
    word-wrap: break-word;
    text-align: center;
    opacity: 1;

    animation: ${TOAST_ANIMATION_TIME.FADE_IN_DURATION}s
        cubic-bezier(0.65, 0, 0.35, 1),
      ${TOAST_ANIMATION_TIME.FADE_IN_DELAY}s forwards fadeIn,
      ${TOAST_ANIMATION_TIME.FADE_OUT_DURATION}s cubic-bezier(0.65, 0, 0.35, 1)
        ${TOAST_ANIMATION_TIME.FADE_OUT_DELAY}s forwards fadeOut,
      0s step-end ${TOAST_ANIMATION_TIME.TIME_OUT}s forwards hide;

    @keyframes fadeIn {
      100% {
        opacity: 1;
      }
    }

    @keyframes fadeOut {
      100% {
        opacity: 0;
      }
    }

    @keyframes hide {
      100% {
        position: absolute;
        bottom: -2000px;
      }
    }
  `;

const GlobalToast = () => {
  const { toastList, clearAllToastList } = useToastStore((state) => state);

  useEffect(() => {
    const toastListTimeout = setTimeout(() => {
      clearAllToastList();
    }, TOAST_ANIMATION_TIME.TIME_OUT * 1000);

    return () => clearTimeout(toastListTimeout);
  }, [clearAllToastList, toastList]);

  useEffect(() => {
    clearAllToastList();
  }, [clearAllToastList]);

  return (
    <div css={toastContainerCSS}>
      <div className="toastWrapper">
        {toastList.map((toast, index) => (
          <div
            css={contentContainerCSS(toast.height)}
            key={index}
            onClick={() => toast.onClick?.()}
          >
            {toast.text}
          </div>
        ))}
      </div>
    </div>
  );
};

export default GlobalToast;
